export const GET_ALL_STEPS_REQUEST = "GET_ALL_STEPS_REQUEST"
export const GET_ALL_STEPS_SUCCESS = "GET_ALL_STEPS_SUCCESS"
export const GET_ALL_STEPS_FAIL = "GET_ALL_STEPS_FAIL"
